<template>
	<div class="company-information-card">
		<div class="company-information-card__header" v-if="item.isPrimary">
			Primary
		</div>
		
		<div class="company-information-card__body">
			<div class="company-information-card__item">
				<span v-if="item.phoneType === 'fax'">Fax: </span>
				{{ item.phoneNumber }}
			</div>

			<div class="company-information-card__item">
				<span class="company-information-card__item-label"
					>Department: </span
				>{{ item.department }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CompanyInformationCard',
	components: {},
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-information-card {
	@include card;
	padding: 0;
	width: 242px;
	overflow: hidden;

	&__header {
		width: 100%;
		background-color: $base;
		padding: $padding-sm $padding-md;
		@include body-text('regular-emphasis');
		color: $white;
	}

	&__body {
		padding: $padding-sm $padding-md;
		@include body-text('regular');
	}

	&__item {
		&:not(:last-child) {
			margin-bottom: $gutter-sm;
		}

		&-label {
			color: $neutral-2;
		}
	}
}
</style>
